import { Phone, Instagram, Youtube, ChevronLeft } from 'lucide-react';
import Link from 'next/link';
import Image from 'next/image';
import SectionContainer from '../utils/section-container';
import { Button } from '../ui/button';
import Icons from '../ui/icons';

type FooterLink = {
    title: string;
    links: string[];
};


type TrustBadge = {
    src: string;
    alt: string;
    width: number;
    href?: string;
};

export default function Footer() {
    const footerSections: FooterLink[] = [
        {
            title: 'فروشگاه بازی تور',
            links: ['آیتم‌های بازی', 'گیفت کارت‌ها', 'تماس با ما', 'درباره ما', 'سوالات متداول']
        },
        {
            title: 'راهنمای خرید',
            links: ['راهنمای خرید آیتم', 'نحوه فعال‌سازی گیفت کارت', 'قوانین تحویل آنی', 'بازگشت وجه', 'سفارش سازمانی', 'پیگیری سفارش']
        },
        {
            title: 'لینک‌های کاربردی',
            links: ['حساب کاربری', 'تخفیف‌های ویژه', 'آیتم‌های تحویل آنی', 'اخبار دنیای گیم', 'بلاگ آموزشی', 'فرصت‌های همکاری']
        }
    ];


    const popularTags: string[] = [
        'استیم والت آمریکا',
        'یوسی پابجی موبایل',
        'CP کالاف دیوتی',
        'باندل Apex Legends',
        'وی‌باکس فورتنایت',
        'گیفت کارت پلی استیشن',
    ];



    const trustBadges: TrustBadge[] = [
        { src: '/logos/enamad.png', alt: 'نماد اعتماد الکترونیکی', width: 1000, href: 'https://trustseal.enamad.ir/?id=592817&Code=iJ8PNpmhFVCbyzR0HdR0aWypfDMUfdp6' },
        { src: '/logos/mellat.png', alt: 'درگاه پرداخت ملت', width: 1000 },
        { src: '/logos/zarinpal.png', alt: 'درگاه پرداخت زرین‌پال', width: 40 }
    ];

    return (
        <footer className="w-full bg-background text-white text-sm pt-12 space-y-14">
            {/* بخش اینستاگرام */}
            <section className="w-full bg-gradient-to-r from-[#0A0512] via-[#141414] to-[#0A0512] relative z-10 2xl:px-0 px-10">
                <div className="absolute inset-0 opacity-20  bg-repeat" />
                {/* bg-[url('/pattern/waves.svg')] */}
                <div className="relative md:max-w-screen-xl mx-auto flex flex-col md:flex-row md:items-center justify-between px-4 py-6 z-10">
                    <div className="w-20 md:w-32 aspect-square absolute z-20">
                        <Image
                            src="/gallery/Instagram.svg"
                            alt="instagram logo"
                            fill
                            className="object-contain"
                            sizes="100%"
                        />
                    </div>
                    <div className="flex items-center gap-0 md:gap-24 md:mr-0 mr-5">
                        <div className="w-20 md:w-40" />
                        <h2 className="text-white text-sm sm:text-3xl font-semibold z-10">
                            از آخرین تخفیف‌های ما جا نمونی...
                        </h2>
                    </div>
                    <Button
                        variant="subtle"
                        className="text-sm sm:text-base font-medium text-gray-300 rounded-full px-5 py-2 shadow flex items-center gap-1 z-10 mr-5 md:mr-0"
                    >
                        <span>اینستاگرام <span className="text-[#8400ff] font-bold">بازی تور</span></span>
                        <ChevronLeft className="w-4 h-4" />
                    </Button>
                </div>
            </section>

            {/* محتوای اصلی فوتر */}
            <SectionContainer>
                <div className="relative p-6 md:p-0">

                    {/* گرید اصلی */}
                    <div className="relative grid grid-cols-1 lg:grid-cols-4 gap-10">


                        {/* بخش لینک‌ها */}
                        <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-8">
                            {footerSections.map((section, idx) => (
                                <div key={idx} className="space-y-4">
                                    <h4 className="relative inline-flex items-center text-lg font-bold text-white">
                                        <span className="absolute -right-3 w-1.5 h-1.5 rounded-full bg-primary" />
                                        {section.title}
                                    </h4>
                                    <ul className="space-y-3">
                                        {section.links.map((link, i) => (
                                            <li key={i}>
                                                <Link
                                                    href="#"
                                                    className="text-muted-foreground hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group"
                                                >
                                                    <span className="w-1 h-1 rounded-full bg-muted-foreground group-hover:bg-primary transition-colors" />
                                                    {link}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>

                        {/* بخش تماس و پیگیری */}
                        <div className="lg:col-span-1 space-y-6">
                            {/* باکس شماره تماس */}
                            <div className="relative group">
                                <div className="absolute inset-0 bg-gradient-to-r from-primary-light via-primary to-primary-dark blur-xl opacity-20 group-hover:opacity-30 transition-opacity" />
                                <div className="relative bg-gradient-to-r from-primary-dark to-primary p-6 rounded-2xl overflow-hidden">
                                    <div className="absolute -right-4 -bottom-4 w-24 h-24 bg-white/10 rounded-full blur-2xl" />
                                    <div className="flex items-start gap-4">

                                        <div>
                                            <p className="text-white/80 text-sm mb-1">پاسخگوی شما هستیم</p>
                                            <h3 className="text-lg font-bold text-white" dir="ltr">02122334455</h3>
                                            <p className="text-xs text-white/60 mt-2">همه روزه از ساعت ۸ صبح تا ۸ شب</p>
                                        </div>

                                        <div className="p-3 bg-white/10 rounded-xl">
                                            <Phone className="w-6 h-6 text-white" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* باکس پیگیری سفارش */}
                            {/* <div className="bg-card/50 p-6 rounded-2xl border border-border/5">
                                <h4 className="flex items-center gap-2 text-lg font-bold text-white mb-4">
                                    <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                                    پیگیری سفارشات
                                </h4>
                                <p className="text-xs text-muted-foreground mb-4">
                                    شماره سفارش خود را وارد کنید
                                </p>
                                <div className="flex gap-2">
                                    <input
                                        type="text"
                                        placeholder="شماره سفارش..."
                                        className="flex-1 bg-card rounded-sm px-4 py-1.5 text-sm border border-border/5 focus:border-primary/50 outline-none transition-colors"
                                    />
                                    <button className="bg-primary hover:bg-primary-dark text-white px-6 py-1.5 rounded-sm text-sm font-medium transition-colors">
                                        پیگیری
                                    </button>
                                </div>
                            </div> */}
                        </div>
                    </div>

                    {/* بخش میانی - تگ‌ها و نمادها */}
                    <div className="mt-12 py-8 border-y border-border/30">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {/* تگ‌های پربازدید */}
                            <div className="space-y-4">
                                <h4 className="relative inline-flex items-center text-lg font-bold text-white">
                                    <span className="absolute -right-3 w-1.5 h-1.5 rounded-full bg-primary" />
                                    بیشترین جستجو
                                </h4>
                                <div className="grid grid-cols-4 gap-2 ">
                                    {popularTags.map((tag, i) => (
                                        <Link
                                            key={i}
                                            href="#"
                                            className=" bg-card text-center hover:bg-card/80 text-xs text-muted-foreground hover:text-white rounded-sm border border-border/5 transition-colors"
                                        >
                                            #{tag}
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            {/* نمادهای اعتماد */}
                            <div className="flex items-center justify-end gap-4">
                                {trustBadges.map((badge, i) => (
                                    <div key={i} className="group">
                                        <Link href={badge.href || '#'} className="w-20 h-20 flex items-center justify-center p-3 bg-card hover:bg-card/80 rounded-2xl border border-border/5 transition-all hover:scale-105 hover:border-[1px] hover:border-[#2A2633]">
                                            <Image
                                                src={badge.src}
                                                alt={badge.alt}
                                                width={badge.width}
                                                height={badge.width}
                                            />
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* بخش پایینی */}
                    <div className="mt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
                        {/* لینک‌های قانونی */}
                        <div className="flex items-center gap-6">
                            <Link href="#" className="text-sm text-muted-foreground hover:text-white transition-colors">
                                قوانین و مقررات
                            </Link>
                            <Link href="#" className="text-sm text-muted-foreground hover:text-white transition-colors">
                                حریم خصوصی
                            </Link>
                            <Link href="#" className="text-sm text-muted-foreground hover:text-white transition-colors">
                                تاریخچه تغییرات
                            </Link>
                        </div>

                        {/* شبکه‌های اجتماعی */}
                        <div className="flex items-center gap-4 mt-4 lg:mt-0">
                            <div className="w-10 h-10 rounded-full overflow-hidden inner-shadow flex flex-col items-center justify-center relative cursor-pointer group">
                                <Icons.tool1 className="w-4 h-4 translate-y-2 group-hover:-translate-y-20 transition-transform transform-gpu duration-500" />
                                <Icons.tool1 className="w-4 h-4 translate-y-20 group-hover:-translate-y-2 transition-transform transform-gpu duration-500" />
                            </div>
                            <div className="w-10 h-10 rounded-full overflow-hidden inner-shadow flex flex-col items-center justify-center relative cursor-pointer group">
                                <Icons.tool2 className="w-4 h-4 translate-y-2 group-hover:-translate-y-20 transition-transform transform-gpu duration-500" />
                                <Icons.tool2 className="w-4 h-4 translate-y-20 group-hover:-translate-y-2 transition-transform transform-gpu duration-500" />
                            </div>
                            <div className="w-10 h-10 rounded-full overflow-hidden inner-shadow flex flex-col items-center justify-center relative cursor-pointer group">
                                <Icons.tool3 className="w-4 h-4 translate-y-2 group-hover:-translate-y-20 transition-transform transform-gpu duration-500" />
                                <Icons.tool3 className="w-4 h-4 translate-y-20 group-hover:-translate-y-2 transition-transform transform-gpu duration-500" />
                            </div>
                            <div className="w-10 h-10 rounded-full overflow-hidden inner-shadow flex flex-col items-center justify-center relative cursor-pointer group">
                                <Icons.tool4 className="w-4 h-4 translate-y-2 group-hover:-translate-y-20 transition-transform transform-gpu duration-500" />
                                <Icons.tool4 className="w-4 h-4 translate-y-20 group-hover:-translate-y-2 transition-transform transform-gpu duration-500" />
                            </div>
                        </div>
                    </div>

                    {/* کپی‌رایت */}
                    <div className="mt-8 pt-6 border-t border-border/30 flex flex-col sm:flex-row justify-between items-center gap-4">
                        <div className="flex items-center gap-3">
                            <p>لوگو</p>
                            {/* <Image
                                src="/logos/digiplus-logo.png"
                                alt="DigiPlus"
                                width={120}
                                height={40}
                                className="opacity-80"
                            />
                            <Image
                                src="/logos/digiplus-icon.png"
                                alt="DigiPlus Icon"
                                width={32}
                                height={32}
                                className="opacity-80"
                            /> */}
                        </div>
                        <p className="text-sm text-muted-foreground text-center">
                            تمامی حقوق برای <span className="text-primary font-semibold">فروشگاه اینترنتی بازی تور</span> محفوظ است.
                        </p>
                    </div>
                </div>
            </SectionContainer>
        </footer>
    );
}
